<div class="main-wraper">
  <szz-header [model]="model()" [sidebarOpen]="sidebarOpen()" (logout)="logout()" (toggleSidebar)="toggleSidebar()"></szz-header>
  <div id="wrapper" class="d-flex">
    <szz-sidebar [isOpen]="sidebarOpen()" [userName]="model().fullName" [isAdmin]="model().isAdmin" (logout)="logout()"></szz-sidebar>
    @if (sidebarOpen()) {
      <div class="sidebar-backdrop" role="button" tabindex="0" aria-label="Zapri meni"
        (click)="closeSidebar()" (keydown.enter)="$event.preventDefault(); closeSidebar()" (keydown.space)="$event.preventDefault(); closeSidebar()" (keydown.escape)="closeSidebar()"></div>
    }
    <div id="content-wrapper" class="flex-grow-1">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
